import { render, staticRenderFns } from "./shiyong.vue?vue&type=template&id=2329accc&scoped=true"
import script from "./shiyong.vue?vue&type=script&lang=js"
export * from "./shiyong.vue?vue&type=script&lang=js"
import style0 from "./shiyong.vue?vue&type=style&index=0&id=2329accc&prod&lang=less&scoped=true"
import style1 from "./shiyong.vue?vue&type=style&index=1&id=2329accc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2329accc",
  null
  
)

export default component.exports